import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { InvoiceRepository } from './domain/interfaces/invoice-repository.interface';
import { ShippingAccountingRepository } from './domain/interfaces/shipping-accounting-repository.interface';
import { ExecuteInvoiceActionUseCase } from './domain/use-cases/execute-invoice-action.use-case';
import { GetInvoiceActionRulesUseCase } from './domain/use-cases/get-invoice-action-rules.use-case';
import { GetInvoiceSummaryUseCase } from './domain/use-cases/get-invoice-summary.use-case';
import { GetInvoicesUseCase } from './domain/use-cases/get-invoices.use-case';
import { GetShippingAccountingUseCase } from './domain/use-cases/get-shipping-accounting.use-case';
import { SendShippingEmailUseCase } from './domain/use-cases/send-shipping-email.use-case';
import { DownloadShippingCsvUseCase } from './domain/use-cases/download-shipping-csv.use-case';
import { ExportInvoicesCsvUseCase } from './domain/use-cases/export-invoices-csv.use-case';
import { GetInvoiceRevenueEditDataUseCase } from './domain/use-cases/get-invoice-revenue-edit-data.use-case';
import { UpdateInvoiceRevenueUseCase } from './domain/use-cases/update-invoice-revenue.use-case';
import { InvoiceFilterAdapter } from './data/adapters/invoice-filter.adapter';
import { ShippingAccountingFilterAdapter } from './data/adapters/shipping-accounting-filter.adapter';
import { InvoiceMapper } from './data/mappers/invoice.mapper';
import { InvoiceRevenueEditMapper } from './data/mappers/invoice-revenue-edit.mapper';
import { ShippingAccountingMapper } from './data/mappers/shipping-accounting.mapper';
import { HttpInvoiceRepository } from './data/repositories/http-invoice.repository';
import { HttpShippingAccountingRepository } from './data/repositories/http-shipping-accounting.repository';
import { InvoiceApiService } from './data/services/invoice-api.service';
import { InvoiceActionButtonsComponent } from './presentation/components/invoice-action-buttons/invoice-action-buttons.component';
import { InvoiceCardComponent } from './presentation/components/invoice-card/invoice-card.component';
import { InvoiceCardListComponent } from './presentation/components/invoice-card-list/invoice-card-list.component';
import { InvoiceErrorBannerComponent } from './presentation/components/invoice-error-banner/invoice-error-banner.component';
import { InvoiceStatusBadgeComponent } from './presentation/components/invoice-status-badge/invoice-status-badge.component';
import { InvoiceSummaryComponent } from './presentation/components/invoice-summary/invoice-summary.component';
import { InvoiceSupportBannerComponent } from './presentation/components/invoice-support-banner/invoice-support-banner.component';
import { ShippingAccountingListComponent } from './presentation/components/shipping-accounting-list/shipping-accounting-list.component';
import { ShippingAccountingSendModalComponent } from './presentation/components/shipping-accounting-send-modal/shipping-accounting-send-modal.component';
import { InvoiceRevenueEditModalComponent } from './presentation/components/invoice-revenue-edit-modal/invoice-revenue-edit-modal.component';
import { InvoiceListContainerComponent } from './presentation/containers/invoice-list-container/invoice-list-container.component';
import { ShippingAccountingContainerComponent } from './presentation/containers/shipping-accounting-container/shipping-accounting-container.component';
import { InvoiceFacade } from './presentation/facades/invoice.facade';
import { ShippingAccountingFacade } from './presentation/facades/shipping-accounting.facade';
import { InvoicePageComponent } from './presentation/pages/invoice-page/invoice-page.component';
import { InvoiceStore } from './presentation/store/invoice.store';
import { ShippingAccountingStore } from './presentation/store/shipping-accounting.store';
import { TableModule } from "primeng/table";

@NgModule({
  declarations: [
    InvoicePageComponent,
    InvoiceListContainerComponent,
    InvoiceCardComponent,
    InvoiceCardListComponent,
    InvoiceSummaryComponent,
    InvoiceErrorBannerComponent,
    InvoiceSupportBannerComponent,
    InvoiceStatusBadgeComponent,
    InvoiceActionButtonsComponent,
    InvoiceRevenueEditModalComponent,
    ShippingAccountingContainerComponent,
    ShippingAccountingListComponent,
    ShippingAccountingSendModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TableModule
],
  exports: [
    InvoicePageComponent,
    ShippingAccountingContainerComponent,
  ],
  providers: [
    InvoiceApiService,
    InvoiceMapper,
    InvoiceRevenueEditMapper,
    InvoiceFilterAdapter,
    InvoiceStore,
    InvoiceFacade,
    GetInvoicesUseCase,
    GetInvoiceSummaryUseCase,
    GetInvoiceActionRulesUseCase,
    ExecuteInvoiceActionUseCase,
    ExportInvoicesCsvUseCase,
    GetInvoiceRevenueEditDataUseCase,
    UpdateInvoiceRevenueUseCase,
    {
      provide: InvoiceRepository,
      useClass: HttpInvoiceRepository,
    },
    ShippingAccountingMapper,
    ShippingAccountingFilterAdapter,
    ShippingAccountingStore,
    ShippingAccountingFacade,
    GetShippingAccountingUseCase,
    SendShippingEmailUseCase,
    DownloadShippingCsvUseCase,
    {
      provide: ShippingAccountingRepository,
      useClass: HttpShippingAccountingRepository,
    },
  ],
})
export class InvoiceFeatureModule {}
